import Vue from 'vue'

export default {
    namespaced: true,

    state: {
  
    },

    mutations: {
     
    },

    actions: {
        success({commit}, message) {
            Vue.prototype.$notify(
                {
                  message: message,
                  icon: 'fa fa-check',
                  horizontalAlign: 'right',
                  verticalAlign: 'top',
                  type: 'success'
                })
        },
        error({commit}, message) {
            Vue.prototype.$notify(
                {
                  message: message,
                  icon: 'fa fa-exclamation-triangle',
                  horizontalAlign: 'right',
                  verticalAlign: 'top',
                  type: 'danger'
                })
        },
       //
    },

    getters: {
        
    },
}